import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificacoesGeraisChatComponent } from '../chat/notificacoes-gerais-chat/notificacoes-gerais-chat.component';

@Component({
  selector: 'app-componente-notificacoes',
  standalone: true,
  imports: [CommonModule, NotificacoesGeraisChatComponent],
  templateUrl: './componente-notificacoes.component.html',
  styleUrl: './componente-notificacoes.component.css'
})

export class ComponenteNotificacoesComponent implements OnInit {
  public permissoesUsuario!: string[];
  constructor() {}

  ngOnInit(): void {
    this.permissoesUsuario = this.recuperarPermissoesLocalStorage();
  }

  private recuperarPermissoesLocalStorage(): string[] {
    try {
      const permissoes = localStorage.getItem('permissoes');
      return permissoes ? JSON.parse(permissoes) : [];
    } catch {
      return [];
    }
  }
}
